import EntityTable from '@shared/components/tables/entity-table/entity-table.vue';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import { Component } from 'vue-property-decorator';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import { Period } from '@centers/interfaces/period';
import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import { mixins } from 'vue-class-component';
import AbstractTable from '@shared/components/tables/abstract-table/abstract-table';
import StdFilter from '@shared/components/filters/std-filter/std-filter.vue';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';

@Component({
  name: 'bpc-period-table',
  components: {
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-entity-table': EntityTable,
    'bpc-page-title': BpcPageTitle,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-std-form': StdForm,
    'bpc-std-filter': StdFilter,
    'bpc-drawer-modal': DrawerModal,
  },
})
export default class PeriodTable extends mixins(AbstractTable) {
  public entity: Period = null;
  public entityName = 'period';
  public pluralEntityName = 'periods';

  public flagsToCheckBeforeLoadEntities: string[] = [
    'configLoaded',
    'filtersLoaded',
    'paginationLoaded',
    'orderLoaded',
    'urlParametersLoaded',
  ];

  public customPageActions = {};
  public customRowActions = {};

  constructor() {
    super();
  }

  setEntityAttributesAfterSave() {
    const newEntity = {} as Period;
    Object.keys(this.entity).forEach(key => {
      this.$set(newEntity, key, null);
    });

    this.$set(newEntity, 'status', this.entity.status);
    this.$set(this.$refs.stdForm, 'formModel', newEntity);

    this.showForm = true;
    this.showDrawerSection = true;
  }

  /* Lifecycle hooks */

  // created() { }
  // mounted() {}
  // updated () { }
  // destroyed () { }
}
